(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335,98374,9469],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(30078);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var global_Loading_SecondarySpinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32447);

__webpack_require__(14473);


var ArticleLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74885), __webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(78656), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(88069), __webpack_require__.e(46819), __webpack_require__.e(7648), __webpack_require__.e(25935), __webpack_require__.e(51225), __webpack_require__.e(80129), __webpack_require__.e(40142), __webpack_require__.e(80737), __webpack_require__.e(50299), __webpack_require__.e(29117), __webpack_require__.e(54253), __webpack_require__.e(54005), __webpack_require__.e(91036), __webpack_require__.e(76750), __webpack_require__.e(97751), __webpack_require__.e(75216), __webpack_require__.e(44912), __webpack_require__.e(62571), __webpack_require__.e(64435), __webpack_require__.e(74768), __webpack_require__.e(40927), __webpack_require__.e(77284), __webpack_require__.e(42227), __webpack_require__.e(15712)]).then(__webpack_require__.bind(__webpack_require__, 12661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12661)
            ];
        }
    }
});
var Contact = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(78656), __webpack_require__.e(75819), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(76750), __webpack_require__.e(33082), __webpack_require__.e(97751), __webpack_require__.e(42786), __webpack_require__.e(42227), __webpack_require__.e(22647), __webpack_require__.e(3907)]).then(__webpack_require__.bind(__webpack_require__, 59127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59127)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Loading_SecondarySpinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
});
var ContactContent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38820).then(__webpack_require__.bind(__webpack_require__, 38820));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38820)
            ];
        }
    }
});
var ContactPage = function(param) {
    var isLoggedIn = param.isLoggedIn;
    if (isLoggedIn) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLayout, {
            source: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactContent, {}),
            title: "Contact"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Contact, {});
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ContactPage);


/***/ }),

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c038202d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      transform: rotate(360deg);\n      opacity: 1;\n    }\n  }\n\n  > div {\n    display: block;\n    margin: auto;\n    height: ",
        ";\n    width: ",
        ";\n    animation: rotate 0.8s infinite linear;\n    border-radius: 50%;\n    border: solid 1.5px ",
        ";\n    border-right-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// eslint-disable-next-line space-infix-ops
var SecondarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bfa5182-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#6b6b6b";
});
var SecondarySpinner = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? "18px" : _size, text = _param.text, _color = _param.color, color = _color === void 0 ? "#6b6b6b" : _color, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "size",
        "text",
        "color",
        "isLoading"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            direction: "column",
            justify: "center",
            align: "center"
        }, props), {
            "data-cy": "global-loading-spinner-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondarySpinnerDiv, {
                    size: size,
                    color: color,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: text,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        family: "light",
                        padding: "20px 0 0 0",
                        children: text
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondarySpinner);


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 91864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.6.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [63332,49774,92888,40179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);